<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>

<div mat-dialog-title class="modal-header header-radius-4">
    <div class="mx-3 d-flex justify-content-between align-items-center">
        <div>
            <h4>Add New Member</h4>
        </div>
        <div>
            <button mat-dialog-close class="close close-btn" type="button">
                <i class="fa fa-close"></i>
            </button>
        </div>
    </div>
</div>
<mat-dialog-content>
    <div class="p-0 mx-4 mb-4">
        <form #addNewMemberForm="ngForm" name="addNewMemberForm">
            <div *ngIf="!isCustomer && !isVendor && !isInternalDriver" class="form-group col-sm-12 col-xs-12">
                <label class="radio-inline">
                    <input
                        class="margin-top-2"
                        name="member"
                        name="memberType"
                        title="Internal Member"
                        type="radio"
                        [value]="true"
                        [(ngModel)]="memberType"
                        (ngModelChange)="radioButtonChange()"
                    />
                    <span>Internal</span>
                </label>
                <label class="radio-inline">
                    <input
                        class="margin-top-2"
                        name="member"
                        name="memberType"
                        title="External Member"
                        type="radio"
                        [value]="false"
                        [(ngModel)]="memberType"
                        (ngModelChange)="radioButtonChange()"
                    />
                    <span>External</span>
                </label>
            </div>
            <ng-container *ngIf="memberType">
                <div class="form-group col-sm-6 col-xs-12">
                    <label>Select Member</label>
                    <ng-multiselect-dropdown-angular7
                        #internalMember="ngModel"
                        name="internalMember"
                        placeholder="Select Member"
                        [settings]="internalMemberDataModel.dropdownSetting"
                        [data]="internalMemberDataModel.internalMemberList"
                        [(ngModel)]="internalMemberDataModel.selectedInternalMemberList"
                        (ngModelChange)="checkSelectionLimit()"
                    >
                    </ng-multiselect-dropdown-angular7>
                </div>
            </ng-container>
            <ng-container *ngIf="!memberType">
                <ng-container *ngIf="!isInternalDriver && !isVendor">
                    <div class="form-group col-sm-6">
                        <label>Customer Name</label>
                        <span class="ml-2">
                            <i *ngIf="customerLoader" class="fa fa-spin fa-spinner text-danger"></i>
                        </span>
                        <input class="form-control" disabled type="text" [value]="customerBusinessUnitName" />
                    </div>
                    <div class="form-group col-sm-6 col-xs-12">
                        <label>Select Member</label>
                        <span class="ml-2">
                            <i *ngIf="customerMemberLoader" class="fa fa-spin fa-spinner text-danger"></i>
                        </span>
                        <ng-multiselect-dropdown-angular7
                            #customerMember="ngModel"
                            name="customerMember"
                            placeholder="Select Customer Member"
                            [settings]="customerMemberDataModel.dropdownSetting"
                            [data]="customerMemberDataModel.customerMemberList"
                            [(ngModel)]="customerMemberDataModel.selectedCustomerMemberList"
                            (ngModelChange)="checkSelectionLimit()"
                        >
                        </ng-multiselect-dropdown-angular7>
                    </div>
                </ng-container>
                <ng-container *ngIf="!isInternalDriver && !isCustomer">
                    <div *ngIf="!this.isVendor" class="form-group col-sm-6 col-xs-12">
                        <label>Select Vendor</label>
                        <span class="ml-2">
                            <i *ngIf="vendorLoader" class="fa fa-spin fa-spinner text-danger"></i>
                        </span>
                        <ngx-select-dropdown
                            id="vendor"
                            name="vendor"
                            placeholder="Select Vendor"
                            tabindex="0"
                            [config]="vendorDataModel.dropdownSetting"
                            [multiple]="false"
                            [options]="vendorDataModel.vendorList"
                            [(ngModel)]="vendorDataModel.selectedVendor"
                            (ngModelChange)="getVendorMemberList(vendorDataModel.selectedVendor)"
                        >
                        </ngx-select-dropdown>
                    </div>
                    <div *ngIf="isVendor" class="form-group col-sm-6">
                        <label>Vendor Name</label>
                        <span class="ml-2">
                            <i *ngIf="vendorLoader" class="fa fa-spin fa-spinner text-danger"></i>
                        </span>
                        <input class="form-control" disabled type="text" [value]="vendorBusinessUnitName" />
                    </div>
                    <div class="form-group col-sm-6 col-xs-12">
                        <label>Select Member</label>
                        <span class="ml-2">
                            <i *ngIf="vendorMemberLoader" class="fa fa-spin fa-spinner text-danger"></i>
                        </span>
                        <ng-multiselect-dropdown-angular7
                            #vendorMember="ngModel"
                            name="vendorMember"
                            placeholder="Select Vendor Member"
                            [settings]="vendorMemberDataModel.dropdownSetting"
                            [data]="vendorMemberDataModel.vendorMemberList"
                            [(ngModel)]="vendorMemberDataModel.selectedVendorMemberList"
                            (ngModelChange)="checkSelectionLimit()"
                        >
                        </ng-multiselect-dropdown-angular7>
                    </div>
                </ng-container>
            </ng-container>
            <div class="form-group text-align-end col-sm-12 col-xs-12 padding-y-15">
                <button mat-dialog-close class="flat-butt flat-danger-butt flat-danger-grad-butt mx-2" title="Cancel">Cancel</button>
                <button
                    class="flat-butt flat-info-butt flat-info-grad-butt save-btn mx-2"
                    title="Add member"
                    [disabled]="isAddMemberButtonDisabled"
                    (click)="addMember()"
                >
                    Add Member
                </button>
            </div>
        </form>
    </div>
</mat-dialog-content>
